export const getCity = ({ city }) => city.city;

export const AllCity = ({ city }) => city.allCity;

export const filterCity = ({city}) => city.selectedCity;




